import React from "react"
import useScrollDirection from "./UseScrollDirection"

export function SubscribeBottom() {
  const direction = useScrollDirection()

  return (
    <div
      className={
        "fixed bottom-0 flex justify-between bottom-bar w-full bg-white items-center px-5 md:px-10 border-2 py-1"
      }
    >
      <span
        className="p-2 px-3 my-1 font-bold text-xs md:text-base tracking-wider theme-button text-white rounded-md lg:block hidden "
        style={{ opacity: 0 }}
      >
        SUBSCRIBE
      </span>
      <div className="md:text-lg text-sm p-1 font-bold">
        Long-form stories take time, money and resources. Pay to keep news free.
      </div>
      <a
        href="https://newslaundry.com/subscription?utm_source=indias_real_estate&utm_medium=subscribe_ticker&utm_campaign=custom_story"
        className="p-2 px-3 my-1 font-bold text-xs md:text-base tracking-wider theme-button text-white rounded-md"
        target="__blank"
      >
        SUBSCRIBE
      </a>
    </div>
  )
}
